var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("report-page", {
    attrs: {
      title: _vm.name,
      "data-to-send": _vm.dataToSend,
      "buttons-disabled": _vm.buttonsDisabled,
      "history-filter": _vm.historyFilter,
      selectedWorkspaceUUID: _vm.selectedWorkspace
    },
    scopedSlots: _vm._u([
      {
        key: "reportForm",
        fn: function() {
          return [
            _c(
              "report-field",
              { attrs: { "field-name": _vm.$tc("Workspace", 1) } },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.workspaceOptions,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.workspaceSelectionDisabled ||
                      !_vm.userHasManagementPermission("workspace", "list"),
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.selectedWorkspace,
                    callback: function($$v) {
                      _vm.selectedWorkspace = $$v
                    },
                    expression: "selectedWorkspace"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: { "field-name": _vm.$t(_vm.reportParameters[0].label) }
              },
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.networkStartingPointOptions,
                    "load-options": _vm.getNetworkStartingPointOptions,
                    disabled:
                      !_vm.hasPermissionToCreateExport ||
                      _vm.technicalSiteLocalDisabled ||
                      !_vm.userHasPermissionToList("technical_local"),
                    "disable-branch-nodes": true,
                    disableFuzzyMatching: ""
                  },
                  model: {
                    value: _vm.reportParameters[0].value,
                    callback: function($$v) {
                      _vm.$set(_vm.reportParameters[0], "value", $$v)
                    },
                    expression: "reportParameters[0].value"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: { "field-name": _vm.$t(_vm.reportParameters[1].label) }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reportParameters[1].value,
                      expression: "reportParameters[1].value"
                    }
                  ],
                  attrs: { type: "number", min: "0" },
                  domProps: { value: _vm.reportParameters[1].value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.reportParameters[1],
                        "value",
                        $event.target.value
                      )
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: { "field-name": _vm.$t(_vm.reportParameters[2].label) }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reportParameters[2].value,
                      expression: "reportParameters[2].value"
                    }
                  ],
                  attrs: { type: "number", min: "0" },
                  domProps: { value: _vm.reportParameters[2].value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.reportParameters[2],
                        "value",
                        $event.target.value
                      )
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "report-field",
              {
                attrs: { "field-name": _vm.$t(_vm.reportParameters[3].label) }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reportParameters[3].value,
                      expression: "reportParameters[3].value"
                    }
                  ],
                  attrs: { type: "number", min: "0" },
                  domProps: { value: _vm.reportParameters[3].value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.reportParameters[3],
                        "value",
                        $event.target.value
                      )
                    }
                  }
                })
              ]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a6930de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a6930de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/ReportsPages/OpticalBudget.vue
// module id = null
// module chunks = 